export const OTPUSK_AUCTION_URL = 'https://birzha.tat.ua/';
export const OTPUSK_API_URL = 'https://api.otpusk.com/api/2.6/';
